<template lang="html">
  <div class="modal">
    <div class="mobile-top-action pt-2 pb-1">
      <button @click="cancelDropdown()"
      class="btn btn-link-action">
        <i class="fal fa-times"></i>
      </button>
      <button @click="resetValues()"
      class="btn btn-link-action">
        reset
      </button>
    </div>
    <div class="advance-select-content py-ns-2">
      <check-list v-model="mutableFilters.typeList"
      title="Type"
      :responsive="true" />
      <check-list v-model="mutableFilters.collectionList"
      title="Suites"
      :responsive="true" />
      <check-list v-model="mutableFilters.exposureList"
      title="View"
      :responsive="true" />
      <check-list v-if="mutableFilters.bathList.length > 1"
      v-model="mutableFilters.bathList"
      title="Bathrooms"
      :responsive="true" />
      <range-slider title="Size"
      :range="{
        min: mutableFilters.sqftRange.min,
        max: mutableFilters.sqftRange.max
      }"
      :defaultRange="mutableFilters.sqftRange.default"
      unitLabel="sqft"
      @change="updateSqftRange"
      class="mb-4" />
      <range-slider title="Floors"
      :range="{
        min: mutableFilters.floorRange.min,
        max: mutableFilters.floorRange.max
      }"
      :defaultRange="mutableFilters.floorRange.default"
      @change="updateFloorRange"
      class="mb-4" />
      <div class="mobile-bottom-spacer"/>
    </div>
    <div
    class="mobile-bottom-action position-absolute w-100">
      <button @click="confirmDropdown()"
      class="btn btn-action w-100">
        apply
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CheckListComponent from '@/components/Input/Checklist';
import RangeSliderComponent from '@/components/input/RangeSlider';

export default {
  data() {
    return {
      mutableFilters: {},
      firstLoad: true,
    };
  },
  computed: {
    ...mapState({
      filters: state => state.floorplans.filters,
    })
  },
  methods: {
    ...mapMutations({
      setFilters: 'floorplans/setFilters'
    }),
    applyFilters() {
      this.setFilters(this.mutableFilters);
    },
    resetTypeFilters() {
      this.mutableFilters.typeList.forEach((type) => { type.active = false; });
    },
    resetCollectionFilters() {
      this.mutableFilters.collectionList.forEach((collection) => { collection.active = false; });
    },
    resetExposureFilters() {
      this.mutableFilters.exposureList.forEach((exposure) => { exposure.active = false; });
    },
    revertMutableFilters() {
      this.mutableFilters = JSON.parse(JSON.stringify(this.filters));
      // if (this.firstLoad) {
      //   this.processSuitesQuery();
      //   this.firstLoad = false;
      // }
    },
    resetMoreFilters() {
      this.mutableFilters.bathList.forEach((bath) => { bath.active = false; });
      this.mutableFilters.sqftRange.min = this.mutableFilters.sqftRange.default.min;
      this.mutableFilters.sqftRange.max = this.mutableFilters.sqftRange.default.max;
      this.mutableFilters.floorRange.min = this.mutableFilters.floorRange.default.min;
      this.mutableFilters.floorRange.max = this.mutableFilters.floorRange.default.max;
    },
    updateSqftRange(newSqftRange) {
      this.mutableFilters.sqftRange.min = newSqftRange.min;
      this.mutableFilters.sqftRange.max = newSqftRange.max;
    },
    updateFloorRange(newFloorRange) {
      this.mutableFilters.floorRange.min = newFloorRange.min;
      this.mutableFilters.floorRange.max = newFloorRange.max;
    },
    resetAllFilters() {
      this.resetTypeFilters();
      this.resetCollectionFilters();
      this.resetExposureFilters();
      this.resetMoreFilters();
    },
    cancelDropdown() {
      this.revertMutableFilters();
      this.$close();
    },
    confirmDropdown() {
      this.applyFilters();
      this.$close();
    },
    resetValues() {
      this.resetAllFilters();
    },
    processSuitesQuery() {
      console.log('process suites query mobile filters?');
      if (this.mutableFilters && this.mutableFilters.collectionList && this.$route.query.suites) {
        const val = this.$route.query.suites;
        console.log(val, this.mutableFilters.collectionList);
        if (this.mutableFilters.collectionList) {
          this.mutableFilters.collectionList.forEach((collection) => {
            console.log(collection, val);
            if (collection.slug === val) {
              collection.active = true;
            }
          });
          this.applyFilters();
        }
      }
    }
  },
  created() {
    this.revertMutableFilters();
  },
  components: {
    'check-list': CheckListComponent,
    'range-slider': RangeSliderComponent
  }
};
</script>

<style lang="scss" scoped>
$mobile-bar-height: 40px;

.modal {
  background: white;
  /* IOS scroll fix */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.advance-select-content {
  overflow-y: auto;
  overflow-x: hidden;
  font-family: Scandia-Regular, sans-serif;
  // position: absolute;
  height: 100%;
  width: 100%;
  padding: 1rem;
}

.mobile-bottom-spacer {
  height: $mobile-bar-height + $app-bar-height;
}

.mobile-top-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  z-index: 999;

  .fa-times {
    font-size: 1.4rem;
  }
}

.mobile-bottom-action {
  height: $mobile-bar-height;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/MobileFloorplanFiltersDialog.vue